"use client"
import { Link, useLocation } from "react-router-dom"
import Tooltip from "@mui/material/Tooltip"

import Hamburger from "../../Static/RawImages/hamburger.png"
import Logo from "../../Static/RawImages/black-ks.png"
import useGeneralStore from "../../store/generalStore"
import useAuthStore from "../../store/authStore"

const isActive = (details, allowed = []) => !!allowed?.includes(details?.key)

// Define litigation panel features
const litigationFeatures = {
  LITIGATION: { key: "LITIGATION" },
  LITIGATION_BATCH: { key: "LITIGATION_BATCH" },
  LITIGATION_CASES: { key: "LITIGATION_CASES" },
}

function LitigationSidebar() {
  const features = useAuthStore((state) => state.features)
  const toggleSidebar = useGeneralStore((state) => state.toggle_sidebar)

  const location = useLocation()

  const checkIfActive = (target) => location.pathname?.toString()?.indexOf(target?.toString()) > -1

  return (
    <>
      <div className="logo">
        <Link to="/admin/litigation/batch">
          <img src={Logo || "/placeholder.svg"} alt="logo" />
        </Link>
      </div>

      <div className="menu-toggle" onClick={() => toggleSidebar()}>
        <img src={Hamburger || "/placeholder.svg"} alt="Hamburger" />
      </div>

      <div className="menu">
        <ul className="nav flex-column">
          <li className="nav-item">
            <div className="accordion" id="accordionMenu">
              {/* Litigation Section */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingLitigation">
                  <div
                    className="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseLitigation"
                    aria-expanded="true"
                    aria-controls="collapseLitigation"
                  >
                    <a
                      className="nav-link"
                      style={
                        checkIfActive("/litigation")
                          ? { fontWeight: "bold", color: "#000000" }
                          : { fontWeight: "normal", color: "#505050" }
                      }
                    >
                      <div className="m-icon" data-toggle="tooltip" data-placement="right" title="Litigation">
                        <Tooltip title="Litigation" placement="right">
                          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#505050" fillRule="nonzero">
                              <path d="M18 2h-6V0H2v2H0v2h2v14h16V4h2V2h-2zM4 2h6v2H4V2zm14 14H2V4h16v12z" />
                              <path d="M4 6h10v2H4zM4 9h10v2H4zM4 12h6v2H4z" />
                            </g>
                          </svg>
                        </Tooltip>
                      </div>
                      <span className="menu-text">Litigation</span>
                    </a>
                  </div>
                </h2>
                <div
                  id="collapseLitigation"
                  className="accordion-collapse show"
                  aria-labelledby="headingLitigation"
                  data-bs-parent="#accordionMenu"
                >
                  <div className="accordion-body">
                    <div className="sidebar_submenu">
                      <ul className="nav flex-column">
                        {/* Batch */}
                        <li className={`nav-item ${checkIfActive("/admin/litigation/batch") && "active"}`}>
                          <Link className="nav-link" to="/admin/litigation/batch">
                            <div className="m-icon">
                              <Tooltip title="Batch" placement="right">
                                <svg width="23" height="19" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M7.933.876A2.333 2.333 0 0 0 5.6 3.21v.466h-.467A2.333 2.333 0 0 0 2.8 6.01v.466h-.275A2.53 2.53 0 0 0 0 9.001v9.609h14.275a2.53 2.53 0 0 0 2.525-2.525v-.275h.467a2.333 2.333 0 0 0 2.333-2.334v-.466h.467a2.333 2.333 0 0 0 2.333-2.334v-9.8H7.933zm7.934 15.209c0 .879-.713 1.591-1.592 1.591H.933V9.001c0-.879.713-1.591 1.592-1.591h13.342v8.675zm2.8-2.609a1.4 1.4 0 0 1-1.4 1.4H16.8v-8.4H3.733V6.01a1.4 1.4 0 0 1 1.4-1.4h13.534v8.866zm2.8-2.8a1.4 1.4 0 0 1-1.4 1.4H19.6v-8.4H6.533V3.21a1.4 1.4 0 0 1 1.4-1.4h13.534v8.866z"
                                    fill="#505050"
                                    fillRule="nonzero"
                                  />
                                </svg>
                              </Tooltip>
                            </div>
                            <span className="menu-text">Batch</span>
                          </Link>
                        </li>

                        {/* Client */}
                        <li className={`nav-item ${checkIfActive("/admin/litigation/client") && "active"}`}>
                          <Link className="nav-link" to="/admin/litigation/client">
                            <div className="m-icon">
                              <Tooltip title="Client" placement="right">
                                <svg width="23" height="19" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M7.933.876A2.333 2.333 0 0 0 5.6 3.21v.466h-.467A2.333 2.333 0 0 0 2.8 6.01v.466h-.275A2.53 2.53 0 0 0 0 9.001v9.609h14.275a2.53 2.53 0 0 0 2.525-2.525v-.275h.467a2.333 2.333 0 0 0 2.333-2.334v-.466h.467a2.333 2.333 0 0 0 2.333-2.334v-9.8H7.933zm7.934 15.209c0 .879-.713 1.591-1.592 1.591H.933V9.001c0-.879.713-1.591 1.592-1.591h13.342v8.675zm2.8-2.609a1.4 1.4 0 0 1-1.4 1.4H16.8v-8.4H3.733V6.01a1.4 1.4 0 0 1 1.4-1.4h13.534v8.866zm2.8-2.8a1.4 1.4 0 0 1-1.4 1.4H19.6v-8.4H6.533V3.21a1.4 1.4 0 0 1 1.4-1.4h13.534v8.866z"
                                    fill="#505050"
                                    fillRule="nonzero"
                                  />
                                </svg>
                              </Tooltip>
                            </div>
                            <span className="menu-text">Client</span>
                          </Link>
                        </li>

                        {/* Cases */}
                        <li className={`nav-item ${checkIfActive("/admin/litigation/cases") && "active"}`}>
                          <Link className="nav-link" to="/admin/litigation/cases">
                            <div className="m-icon">
                              <Tooltip title="Cases" placement="right">
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                  <g fill="#505050" fillRule="nonzero">
                                    <path d="M16 4h-2V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 2h4v2H8V2zm8 16H4V6h2v2h8V6h2v12z" />
                                    <path d="M6 10h8v2H6zM6 13h8v2H6z" />
                                  </g>
                                </svg>
                              </Tooltip>
                            </div>
                            <span className="menu-text">Cases</span>
                          </Link>
                        </li>
                        {/* Add Case */}
                        <li className={`nav-item ${checkIfActive("/admin/litigation/create-case") && "active"}`}>
                          <Link className="nav-link" to="/admin/litigation/create-case">
                            <div className="m-icon">
                              <Tooltip title="Cases" placement="right">
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                  <g fill="#505050" fillRule="nonzero">
                                    <path d="M16 4h-2V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 2h4v2H8V2zm8 16H4V6h2v2h8V6h2v12z" />
                                    <path d="M6 10h8v2H6zM6 13h8v2H6z" />
                                  </g>
                                </svg>
                              </Tooltip>
                            </div>
                            <span className="menu-text">Add Case</span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Invoice Section */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingInvoice">
                  <div
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseInvoice"
                    aria-expanded="false"
                    aria-controls="collapseInvoice"
                  >
                    <a
                      className="nav-link"
                      style={
                        checkIfActive("/invoice")
                          ? { fontWeight: "bold", color: "#000000" }
                          : { fontWeight: "normal", color: "#505050" }
                      }
                    >
                      <div className="m-icon" data-toggle="tooltip" data-placement="right" title="Invoice">
                        <Tooltip title="Invoice" placement="right">
                          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#505050" fillRule="nonzero">
                              <path d="M18 2h-6V0H2v2H0v2h2v14h16V4h2V2h-2zM4 2h6v2H4V2zm14 14H2V4h16v12z" />
                              <path d="M4 6h10v2H4zM4 9h10v2H4zM4 12h6v2H4z" />
                            </g>
                          </svg>
                        </Tooltip>
                      </div>
                      <span className="menu-text">Invoice</span>
                    </a>
                  </div>
                </h2>
                <div
                  id="collapseInvoice"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingInvoice"
                  data-bs-parent="#accordionMenu"
                >
                  <div className="accordion-body">
                    <div className="sidebar_submenu">
                      <ul className="nav flex-column">
                        {/* Manage Invoice */}
                        <li className={`nav-item ${checkIfActive("/admin/invoice/manage") && "active"}`}>
                          <Link className="nav-link" to="/admin/invoice/manage">
                            <div className="m-icon">
                              <Tooltip title="Manage Invoice" placement="right">
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                  <g fill="#505050" fillRule="nonzero">
                                    <path d="M16 4h-2V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 2h4v2H8V2zm8 16H4V6h2v2h8V6h2v12z" />
                                    <path d="M6 10h8v2H6zM6 13h8v2H6z" />
                                  </g>
                                </svg>
                              </Tooltip>
                            </div>
                            <span className="menu-text">Manage Invoice</span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Assignments Section */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingAssignments">
                  <div
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseAssignments"
                    aria-expanded="false"
                    aria-controls="collapseAssignments"
                  >
                    <a
                      className="nav-link"
                      style={
                        checkIfActive("/assignments")
                          ? { fontWeight: "bold", color: "#000000" }
                          : { fontWeight: "normal", color: "#505050" }
                      }
                    >
                      <div className="m-icon" data-toggle="tooltip" data-placement="right" title="Assignments">
                        <Tooltip title="Assignments" placement="right">
                          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#505050" fillRule="nonzero">
                              <path d="M16 4h-2V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 2h4v2H8V2zm8 16H4V6h2v2h8V6h2v12z" />
                              <path d="M6 10h8v2H6zM6 13h8v2H6z" />
                            </g>
                          </svg>
                        </Tooltip>
                      </div>
                      <span className="menu-text">Assignments</span>
                    </a>
                  </div>
                </h2>
                <div
                  id="collapseAssignments"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingAssignments"
                  data-bs-parent="#accordionMenu"
                >
                  <div className="accordion-body">
                    <div className="sidebar_submenu">
                      <ul className="nav flex-column">
                        <li className={`nav-item ${checkIfActive("/admin/assignments/manage") && "active"}`}>
                          <Link className="nav-link" to="/admin/assignments/manage">
                            <div className="m-icon">
                              <Tooltip title="Manage Assignments" placement="right">
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                  <g fill="#505050" fillRule="nonzero">
                                    <path d="M16 4h-2V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 2h4v2H8V2zm8 16H4V6h2v2h8V6h2v12z" />
                                    <path d="M6 10h8v2H6zM6 13h8v2H6z" />
                                  </g>
                                </svg>
                              </Tooltip>
                            </div>
                            <span className="menu-text" style={{ fontSize: "12px" }}>Manage Assignments</span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  )
}

export default LitigationSidebar